import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans du module Crise chargés à la demande (Leaflet seulement avec la carte).
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const pages = () => import('./CrisePages.js');
const VeillePage = page(pages, 'VeillePage');
const PilotagePage = page(pages, 'PilotagePage');
const PartenairesPage = page(pages, 'PartenairesPage');
const AlertesPage = page(pages, 'AlertesPage');
const AdministrationPage = page(pages, 'AdministrationPage');

/** Routes du module Crise (module.json `navigation`, spec 012). */
export const criseWeb: ModuleWeb = {
  module: 'crise',
  routes: [
    { path: '/crise/veille', element: <VeillePage /> },
    { path: '/crise/pilotage', element: <PilotagePage /> },
    { path: '/crise/partenaires', element: <PartenairesPage /> },
    { path: '/crise/alertes', element: <AlertesPage /> },
    { path: '/crise/administration', element: <AdministrationPage /> },
  ],
};
